module.exports = __webpack_public_path__ + "static/media/favicon.5e1a3fdf.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = 138
// module chunks = 2